import { makeCSSAnimations } from './css-animations';

class Hamburger {
    constructor() {
        let _this = this;
        $(document).on(
            'click',
            'button.hamburger, .shop-push__overlay, .shop-push__close',
            () => {
                if (!$('body').hasClass('nav-open')) {
                    this.openNav(); //ОТКРЫТИЕ МЕНЮ
                } else {
                    this.closeNav(); //ЗАКРЫТИЕ МЕНЮ
                }
            }
        );

        $(document).on('keyup', (e) => {
            if (e.keyCode === 27 && $('body').hasClass('nav-open')) {
                this.closeNav();
            }
        });

        document.addEventListener('touchstart', function (e) {
            if ($('body').hasClass('nav-open')) {
                if ($(e.target).closest('.global').length) {
                    _this.closeNav();
                }
            }
        });

        // document.addEventListener('touchmove', function(e){
        //     if( $('body').hasClass('nav-open')) {
        //         if( $(e.target).closest('.global').length ) {
        //             e.preventDefault()
        //         }
        //     }
        // })
    }

    openNav() {
        makeCSSAnimations({
            container: $('body'),
            animationClass: 'nav-opening',
            stateClass: 'nav-open',
            before: function () {
                // $('.shop-header').css({
                //     position: 'absolute',
                //     top: $('.shop-header').offset().top
                // })
                $('.global').append('<div class="shop-push__overlay"></div>');
                setTimeout(() => {
                    $('.shop-push__overlay').addClass('shop-push__overlay--on');
                }, 0);
            },
        });
    }

    closeNav() {
        makeCSSAnimations({
            container: $('body'),
            animationClass: 'nav-closing',
            stateClass: 'nav-open',
            after: function () {
                $('.shop-push__overlay').remove();
                // $('.shop-header').css({
                //     position: '',
                //     top: ''
                // })
            },
            direction: 'back',
        });
    }
}

export const hamburger = new Hamburger();
